import { FormElement, TeamRole } from "app/types";

export enum PLANS {
  MONTHLY = "monthly",
  YEARLY = "yearly",
}
export enum PLAN_TYPE {
  FREE = "free",
  BUSINESS = "business",
  PROFESSIONAL = "professional",
}
export interface PLAN {
  title: PLAN_TYPE;
  caption: string;
  price: number;
  features: string[];
}

export type ProfileForm = {
  name: FormElement;
  password: FormElement;
  confirmPassword: FormElement;
  timezone: FormElement;
  isLoading: boolean;
};

export type SetupForm = {
  companySize: FormElement;
  referalSource: FormElement;
  toolPreferences: FormElement;
  isLoading: boolean;
  isTeamCreated: boolean;
};
export type IDefaultCustomization = {
  agileDevelopmentAndSprints: boolean;
  epicsAndStories: boolean;
  releaseManagement: boolean;
};

export type ITeamForm = {
  name: FormElement;
  project: {
    name: FormElement;
    defaultCustomization: IDefaultCustomization;
  };
  members: TeamMember[];
  plan: PLAN_TYPE;
  coupon: FormElement;
  isLoading: boolean;
  isMemberAdded: boolean;
  isProjectCreated: boolean;
  projectId: string;
  teamId: string;
};

export type TeamMember = {
  name: FormElement;
  role: FormElement;
};
export enum TeamInviteAction {
  ACCEPT = "accept",
  REJECT = "reject",
}
export interface IPasswordField {
  name: string; 
  value: string;
  error?: string;
}

export type IInviteVerification = {
  teamId: string;
  teamName: string;
  teamMemberId: string;
  projectIds: string[];
  email: string;
  teamRole: TeamRole;
  isExistingUser: boolean;
  accessToken: string;
  refreshToken: string;
};
export interface OnBoardingState {
  profileForm: ProfileForm;
  setupForm: SetupForm;
  isLoading: boolean;
  isButtonLoading: boolean;
  onboardingList: {
    companySizes: [];
    referalSources: [];
    toolPreferences: [];
  };
  teamFormActiveIndex: number;
  teamForm: ITeamForm;
  inviteVerification: IInviteVerification;
}
export type ContainerState = OnBoardingState;
